import axios from 'axios';

const CompareService = {
    async add(chosen, id, type) {
        return axios.post('/compare/api/add', {
            chosen,
            id,
            type
        });
    },
    async remove(key) {
        return axios.post('/compare/api/remove', {
            key
        });
    },
    async fetchCheckout() {
        return axios.get('/compare/api/index');
    },
    // async updateCompareList() {
    //     return axios.get('/compare');
    // }
};

export default CompareService;